const filterReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_FILTER_PRODUCTS":
            let priceArr = action.payload.map((curElem) => curElem.price);
            // console.log(
            //     "🚀 ~ file: filterReducer.js ~ line 5 ~ filterReducer ~ priceArr",
            //     priceArr
            // );

            // return {
            //     ...state,
            //     filter_products: [...action.payload],
            //     all_products: [...action.payload],
            // };

            let maxPrice = Math.max(...priceArr);
            // console.log(
            //     "🚀 ~ file: filterReducer.js ~ line 23 ~ filterReducer ~ maxPrice",
            //     maxPrice
            // );

            return {
                ...state,
                filter_products: [...action.payload],
                all_products: [...action.payload],
                filters: { ...state.filters, maxPrice, price: maxPrice },

            };

        case "UPDATE_FILTERS_VALUE":
            const { name, value } = action.payload;

            return {
                ...state,
                filters: {
                    ...state.filters,
                    [name]: value,
                },
            };

        case "FILTER_PRODUCTS":
            let { all_products } = state;
            let tempFilterProduct = [...all_products];

            const { shape, carat, price, color } = state.filters;


            if (shape !== "all") {
                tempFilterProduct = tempFilterProduct.filter((curElem) => {
                    return curElem.shape === shape;
                });

                // tempFilterProduct = tempFilterProduct.filter(
                //     (curElem) => curElem.shape === shape
                // );
            }

            // if (carat) {
            //   tempFilterProduct = tempFilterProduct.filter((curElem) => {
            //     return curElem.carat === carat;
            //   });
            // }

            if (carat !== "all") {
                tempFilterProduct = tempFilterProduct.filter((curElem) =>
                    curElem.carat.includes(carat)
                );
            }

            if (price === 0) {
                tempFilterProduct = tempFilterProduct.filter((curElem) =>
                    curElem.price === price
                );
            } else {
                tempFilterProduct = tempFilterProduct.filter((curElem) =>
                    curElem.price <= price
                );
            }

            // if (color !== "all") {
            //     tempFilterProduct = tempFilterProduct.filter((curElem) =>
            //         curElem.color.includes(color)
            //     );
            // } else {
            //     tempFilterProduct = tempFilterProduct.filter((curElem) =>
            //         curElem.color.includes(color)
            //     );
            // }


            return {
                ...state,
                filter_products: tempFilterProduct,
            };

        default:
            return state;
    }
};

export default filterReducer;